<template>
  <div id="add-user">
    <h2>{{$t('users.add-user-title')}}</h2>
    <form @submit="onCreate">

      <custom-input :inputType="'text'" v-model="user.name" :name="'nameInput'" :label="$t('users.add-user-name-label')" :placeholder="$t('users.add-user-name-ph')" :isRequired="true" :focusInputField="true" />
      <custom-input :inputType="'text'" v-model="user.username" :name="'usernameInput'" :label="$t('users.add-user-email-label')" :placeholder="$t('users.add-user-email-ph')" :isRequired="true" />
      <custom-input :inputType="'password'" v-model="user.password" :name="'passwordInput'" :label="$t('users.add-user-password-label')" :placeholder="$t('users.add-user-password-ph')" :isRequired="true" :invalidInput="passwordIsOk == false"/>
        <p class="small" style="margin-bottom:0;"> 
          {{$t('password-validation.requirements-title')}}
          <span  :class="!passwordMinLength ? 'error-text' : 'succes'">{{$t('password-validation.chars')}}</span>
          <span  :class="!passwordHasCapitalLetter ? 'error-text' :'succes'">{{$t('password-validation.uppercase')}}</span>
          <span  :class="!passwordHasNumber ? 'error-text' : 'succes' ">{{$t('password-validation.number')}}</span>
        </p>
      <custom-input :inputType="'password'" v-model="reenteredpassword" :name="'reenteredPasswordInput'" :label="$t('users.add-user-repeat-label')" :placeholder="$t('users.add-user-repeat-ph')" :isRequired="true" :invalidInput="passwordsMatch == false" />
        <div class="small error-text" v-if="passwordsMatch == false">{{$t('reset-password.succesful-reset')}}</div>
      <custom-input :inputType="'text'" v-model="user.phone" :name="'phoneInput'" :label="$t('users.add-user-phone-label')" :placeholder="$t('users.add-user-phone-ph')" :isRequired="true" />

        <div class="footer">       
            <button
              type="submit"
              class="btn btn-md btn-primary"
              :disabled="!valid"
              @click="onCreate"
              v-bind:loading="true"
            >
              {{$t('users.add-user-btn-add')}}
            </button>
              <button type="reset" class="btn btn-md btn-secondary" @click="$emit('close')">
              {{$t('users.add-user-btn-cancel')}}
            </button>
        </div>
    </form>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import debounce from 'lodash/debounce'
export default {
  props: {
    onSave: Function,
    inputPlaceholder: String,
    title: String,
    allowEmpty: Boolean,

  },
  data() {
    return {
      user: {
        username: "",
        name: "",
        password: "",
        phone: ""
      },
    
    reenteredpassword: "",
     checkPasswordDebounce: debounce((password) => {
            this.checkPassword(password)
            }, 500),
        checkRepeatPasswordDebounce:  debounce((newPassword, newPasswordRepeat) => {
            this.checkRepeatPassword(newPassword, newPasswordRepeat)
            }, 500),
        passwordLength: 0,
        passwordMinLength: false,
        passwordHasCapitalLetter: false,
        passwordHasNumber: false,
        passwordIsOk: null,
        passwordsMatch: null

    };
  },
  computed: {
    valid() {
      return (
        this.user.name &&
        this.user.username &&
        this.user.password == this.reenteredpassword && 
        this.passwordsMatch && this.passwordIsOk
      );
    }
  },
  methods: {
    onCreate(evt) {
      evt.preventDefault();
      this.onSave(this.user)
      this.$emit("close");
      // this.loading = true;
    },
      checkPassword(password){
        // Min requirements - 6 letters, 1 capital, 1 number
        this.passwordLength = password.length
        if(this.passwordLength >= 6){
            this.passwordMinLength = true
        }else this.passwordMinLength = false
        this.passwordHasCapitalLetter = /[A-Z]/.test(password)
        this.passwordHasNumber = /\d/.test(password)
        if(this.passwordMinLength && this.passwordHasCapitalLetter && this.passwordHasNumber){
            this.passwordIsOk = true
        }else {
          this.user.password == '' ? this.passwordIsOk = null : this.passwordIsOk = false
        }
    },
    checkRepeatPassword(newPassword, repeatPassword){
        if(repeatPassword == '')this.passwordsMatch = null
        else{
            if (newPassword === repeatPassword) this.passwordsMatch = true
            else this.passwordsMatch = false
        }
    }
  },
  watch: {
    'user.password': function(value) {
        this.checkPasswordDebounce(this.user.password)
        this.checkRepeatPasswordDebounce(this.user.password, this.reenteredpassword)
	},
	'reenteredpassword': function(value) {  
        this.checkRepeatPasswordDebounce(this.user.password, this.reenteredpassword)
    }
  },
  mounted(){
    // this.$refs.name.focus() 
  },
  components:{
    CustomInput
  }
}
</script>

<style lang="less">
@keyframes dropIn {
  from{
    transform: translateY(-100px);
    opacity: 0.6;
  }
  to{
    transform: translateY(0);
    opacity: 1;
  }
}
  .v--modal-box.v--modal{ 
    animation: dropIn .4s ease ;
  }

  .v--modal-overlay .v--modal-background-click{
    overflow: auto;
  }

#add-user {
    padding: 30px 25px 25px 25px;
   
  h2 {
    margin-bottom: 0;
  }
  form {
    display: flex;
    flex-direction: column;
    .error-text{
      color:#cd4b3d;
    }
    .succes{
      color: #28a745;
    }
  }
  .footer {
    margin-top: 30px;
    display: flex;
    .btn-primary{
      margin-right: 15px;
    }
  }
}
</style>
